import React, { useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import axios from 'axios';
import { FiMapPin } from 'react-icons/fi';
import { useUser } from '../context/useInfo';

export default function CitySelector({ onChange,onFocus, onInputChange, onBlur, defaultCity = '' }) {
  const { updateUserData } = useUser();
  const [selectedCity, setSelectedCity] = useState(
    defaultCity ? { label: defaultCity, value: defaultCity } : null
  );

  useEffect(() => {
  if (defaultCity) {
    setSelectedCity({ label: defaultCity, value: defaultCity });
  } else {
    setSelectedCity(null);
  }
}, [defaultCity]);
  const handleChange = (val) => {
    setSelectedCity(val);
    updateUserData({ location: val.value });
    onChange?.(val.value);
  };

  const loadOptions = async (inputValue, callback) => {
    if (!inputValue) return callback([]);
    try {
      const res = await axios.get(
        `https://nominatim.openstreetmap.org/search?city=${inputValue}&format=json`
      );
      const options = res.data.map((item) => ({
        label: `${item.display_name}`,
        value: `${item.display_name}`,
      }));
      callback(options);
    } catch (err) {
      console.error('Ошибка загрузки городов:', err);
      callback([]);
    }
  };

  return (
    <div className="relative mb-6">
      <div className="absolute left-3 top-3 text-gray-400 z-10">
        <FiMapPin />
      </div>
      <AsyncSelect
        cacheOptions
        defaultOptions
        value={selectedCity}
        loadOptions={loadOptions}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={handleChange}
        onInputChange={(input) => {
          onInputChange?.(input);
          }}
        placeholder={defaultCity ? defaultCity : 'Enter your city'}
        noOptionsMessage={() => 'No cities found'}
        styles={{
          control: (base) => ({
            ...base,
            height: '44px',
            borderRadius: '9999px',
            paddingLeft: '40px',
            borderColor: '#E5E7EB',
            fontSize: '14px',
          }),
        }}
      />
    </div>
  );
}